module.exports = __webpack_public_path__ + "static/media/coral.89bd2b24.jpg";